import BasketCount from './basket-count';
import BasketNotificationsHandler from './basket-notifications-handler';
import EquipmentCardControls from './equipment-card-controls';
import CoffeeCardControls from './coffee-card-controls';
import ToCartBtn from './to-cart-btn';
import ProductPageControls from './coffee-page-controls';
import EquipmentPageControls from './equipment-page-controls';
import DetailOfferImage from './detail-offer-image';
import OrderDeliveriesButtons from './order-deliveries-buttons';
import OrderPersonCompany from './order-person-company';

Vue.component(BasketCount.name, BasketCount);
Vue.component(BasketNotificationsHandler.name, BasketNotificationsHandler);
Vue.component(CoffeeCardControls.name, CoffeeCardControls);
Vue.component(EquipmentCardControls.name, EquipmentCardControls);
Vue.component(ToCartBtn.name, ToCartBtn);
Vue.component(ProductPageControls.name, ProductPageControls);
Vue.component(EquipmentPageControls.name, EquipmentPageControls);
Vue.component(DetailOfferImage.name, DetailOfferImage);
Vue.component(OrderDeliveriesButtons.name, OrderDeliveriesButtons);
Vue.component(OrderPersonCompany.name, OrderPersonCompany);
